module.exports = __webpack_public_path__ + "static/media/magzine2.4271edd7.jpg";